import "../../utils/messages";
import { POLICIES_NOT_RETRIEVED, POLICY_MESSAGES, POLICY_NOT_RETRIEVED } from "../../utils/messages";
import { ClientMessage } from "../../utils/objects";

export function assignPolicyRequests(api) {
    /*********************************POLICIES*********************************************/
    //export const policiesAPI = {

    api.refreshPolicies = async function (computers) {

        var idComputers = computers.map(computer => computer.id);


        var body = JSON.stringify({
            "pc_ids": idComputers
        });
        var response = await api.put('/enterprise/refresh/policies', body, this.buildConfig(process.env.VUE_APP_BASE_URL_ENT))
            .then(res => {
                return res.data;
            })
            .catch(e => {
                this.checkError(e, POLICIES_NOT_RETRIEVED);
                return [];
            });

        return response;
    }
    api.refreshPoliciesWithArray = async function (arrComputers) {

        const ids = (arrComputers || [])
            .map(x => (typeof x === 'string' ? x : x && x.id))
            .filter(Boolean);                   // rimuove null/undefined
        const pc_ids = [...new Set(ids)];     // opzionale: no duplicati
        const body = JSON.stringify({ pc_ids });

        /*var idComputers=computers.map(computer => computer.id);
 
 
        var body=JSON.stringify({
            "pc_ids": idComputers
        });*/
        var response = await api.put('/enterprise/refresh/policies', body, this.buildConfig(process.env.VUE_APP_BASE_URL_ENT))
            .then(res => {
                return res.data;
            })
            .catch(e => {
                this.checkError(e, POLICIES_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.getPolicies = async function () {
        var response = await api.get('/enterprise/policies', this.buildConfig())
            .then(res => {
                return res.data;
            })
            .catch(e => {
                this.checkError(e, POLICIES_NOT_RETRIEVED);
                return [];
            });

        return response;
    }
    api.getPolicyTypes = async function () {
        var response = await api.get('/enterprise/policytypes', this.buildConfig())
            .then(res => {
                return res.data;
            })
            .catch(e => {
                this.checkError(e, POLICIES_NOT_RETRIEVED);
                return [];
            });

        return response;
    }
    api.deletePolicy = async function (idPol) {
        var clientMessage = ClientMessage.success(POLICY_MESSAGES.DELETED);

        var response = await api.delete('/enterprise/policies?id=' + idPol, this.buildConfig())
            .then(response => 200 <= response.status && response.status <= 299)
            .catch(e => {
                clientMessage = this.checkError(e, POLICY_MESSAGES.NOT_DELETED);
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "policymethods");
        return response;
    }
    api.getPolicy = async function (idPol) {
        var response = await api.get('/enterprise/policies?id=' + idPol, this.buildConfig())
            .then(res => {
                return res.data;
            })
            .catch(e => {
                this.checkError(e, POLICY_NOT_RETRIEVED, "policymethods");
                return null;
            });

        return response;
    }
    api.createPolicy = async function (policyObj) {
        var config = this.buildConfig();
        var body = JSON.stringify(policyObj);
        var clientMessage = ClientMessage.success(POLICY_MESSAGES.CREATED);

        var response = await api.post('/enterprise/policies', body, config)
            .then(res => res.data)
            .catch(e => {
                clientMessage = this.checkError(e, POLICY_MESSAGES.NOT_CREATED);
                return null;
            });
        this.emitFunction("sendClientMessage", clientMessage, "policymethods");

        return response;
    }
    api.editPolicy = async function (policyObj) {
        var config = this.buildConfig();
        var body = JSON.stringify(policyObj);
        var clientMessage = ClientMessage.success(POLICY_MESSAGES.MODIFIED);

        var response = await api.put('/enterprise/policies', body, config)
            .then(res => res.data)
            .catch(e => {
                clientMessage = this.checkError(e, POLICY_MESSAGES.NOT_MODIFIED);

                return null;
            });

        this.emitFunction("sendClientMessage", clientMessage, "policymethods");

        return response;
    }
    //}
}
